"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var forms_1 = require("@angular/forms");
var core_1 = require("@angular/core");
var shared_1 = require("../shared");
var sis_workflow_designer_component_1 = require("./workflow-designer/sis-workflow-designer.component");
var sis_workflow_process_management_component_1 = require("./workflow-process-management/sis-workflow-process-management.component");
var confirm_popup_component_1 = require("./confirm-popup/confirm-popup.component");
var workflow_designer_routes_1 = require("./workflow-designer.routes");
var sis_subway_map_component_1 = require("./subway-map/sis-subway-map.component");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var import_export_dialog_component_1 = require("./workflow-process-management/dialogs/import-export-dialog.component");
var change_history_dialog_component_1 = require("./workflow-process-management/dialogs/change-history-dialog.component");
var file_upload_component_1 = require("./workflow-process-management/dialogs/file-upload/file-upload.component");
var workflow_designer_viewport_module_1 = require("./workflow-designer-viewport.module");
var services_1 = require("./services");
var service_provider_1 = require("./service.provider");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var http_1 = require("@angular/common/http");
var ɵ0 = service_provider_1.ServiceProvider.provideIfNotProvided(services_1.LOCALE_SERVICE, idm_locale_service_client_js_1.HttpLocaleService), ɵ1 = service_provider_1.ServiceProvider.provideIfNotProvided(services_1.FORM_MANAGEMENT_SERVICE, services_1.FormManagementHttpService), ɵ2 = service_provider_1.ServiceProvider.provideIfNotProvided(services_1.USER_SERVICE, services_1.UserService), ɵ3 = service_provider_1.ServiceProvider.provideIfNotProvided(services_1.KbService), ɵ4 = service_provider_1.ServiceProvider.provideIfNotProvided(services_1.AUDIT_SERVICE, services_1.AuditService);
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
exports.ɵ3 = ɵ3;
exports.ɵ4 = ɵ4;
/** Main inner Workflow module **/
var MainWorkflowDesignerModule = /** @class */ (function () {
    function MainWorkflowDesignerModule() {
    }
    MainWorkflowDesignerModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [
                        idm_ng_controls_1.ControlsModule,
                        common_1.CommonModule,
                        forms_1.FormsModule,
                        shared_1.MaterialModule,
                        workflow_designer_viewport_module_1.WorkflowDesignerViewportModule,
                        workflow_designer_routes_1.workflowDesignerRouting,
                    ],
                    declarations: [
                        sis_workflow_process_management_component_1.WorkflowProcessManagementComponent,
                        sis_workflow_designer_component_1.WorkflowDesignerComponent,
                        sis_subway_map_component_1.SubwayMapComponent,
                        shared_1.MetaCategoryPipe,
                        confirm_popup_component_1.ConfirmPopup,
                        shared_1.LocalDatePipe,
                        shared_1.UsernamePipe,
                        import_export_dialog_component_1.ImportExportDialogComponent,
                        change_history_dialog_component_1.ChangeHistoryDialogComponent,
                        file_upload_component_1.FileUploadComponent
                    ],
                    exports: [
                        sis_workflow_process_management_component_1.WorkflowProcessManagementComponent,
                        sis_workflow_designer_component_1.WorkflowDesignerComponent,
                        sis_subway_map_component_1.SubwayMapComponent,
                        shared_1.MetaCategoryPipe
                    ],
                    entryComponents: [
                        confirm_popup_component_1.ConfirmPopup,
                        import_export_dialog_component_1.ImportExportDialogComponent,
                        change_history_dialog_component_1.ChangeHistoryDialogComponent
                    ],
                    providers: [
                        service_provider_1.ServiceProvider,
                        services_1.ProcessImportExportService,
                        { provide: services_1.PopUpsService, useClass: services_1.PopUpsServiceImpl },
                        {
                            provide: idm_locale_service_client_js_1.LocaleService,
                            useFactory: ɵ0,
                            deps: [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService, service_provider_1.ServiceProvider]
                        },
                        {
                            provide: services_1.FormManagementService,
                            useFactory: ɵ1,
                            deps: [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService, idm_message_language_service_client_js_1.LanguageService, service_provider_1.ServiceProvider]
                        },
                        {
                            provide: services_1.UserService,
                            useFactory: ɵ2,
                            deps: [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService, service_provider_1.ServiceProvider]
                        },
                        {
                            provide: services_1.KbService,
                            useFactory: ɵ3,
                            deps: [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService, service_provider_1.ServiceProvider]
                        },
                        {
                            provide: services_1.AuditService,
                            useFactory: ɵ4,
                            deps: [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService, service_provider_1.ServiceProvider],
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    MainWorkflowDesignerModule.ctorParameters = function () { return []; };
    return MainWorkflowDesignerModule;
}());
exports.MainWorkflowDesignerModule = MainWorkflowDesignerModule;
//# sourceMappingURL=main-workflow-designer.module.js.map